import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

export default function Header() {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  // Get user display name (fallback to email, username, or User)
  const getDisplayName = () => {
    if (!user) return 'User';
    return user.username || user.email || 'User';
  };

  // Extract first letter for a clean profile avatar
  const getAvatarLetter = () => {
    const name = getDisplayName();
    return name.charAt(0).toUpperCase();
  };

  return (
    <header className="evidence-header">
      <div className="evidence-header-content nav-flex-container">
        <div className="evidence-logo-section nav-brand-section">
          <Link to="/" className="logo-brand-link">
            <h1>Signout GI</h1>
          </Link>
        </div>

        <div className="nav-auth-section">
          {isAuthenticated ? (
            <div className="auth-profile-widget">
              <div className="user-avatar" title={getDisplayName()}>
                {getAvatarLetter()}
              </div>
              <div className="user-info-text">
                <span className="user-welcome">Logged in as</span>
                <span className="user-name" title={getDisplayName()}>
                  {getDisplayName()}
                </span>
              </div>
              <button onClick={handleLogout} className="auth-action-btn logout-btn">
                Log Out
              </button>
            </div>
          ) : (
            <Link to="/login" className="auth-action-btn login-btn">
              <svg className="login-btn-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
              </svg>
              Log In
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
